import { render, staticRenderFns } from "./projectCodeItem.vue?vue&type=template&id=72266bd0&scoped=true&"
import script from "./projectCodeItem.vue?vue&type=script&lang=js&"
export * from "./projectCodeItem.vue?vue&type=script&lang=js&"
import style0 from "./projectCodeItem.vue?vue&type=style&index=0&id=72266bd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72266bd0",
  null
  
)

export default component.exports